import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class Activity{
    static attributePrefix = "Activity";
    static attributePrefixDe = "Aktivität";}